import Cookies from 'js-cookie';
import Main from '../_modules/main';

class AgeGate {
    constructor() {
        this.components = document.querySelectorAll('.m-age-gate');
        this.Main = new Main();
        // this.lenis = lenis;

        this.components.forEach((component) => {
            this.init(component);
        });
    }

    init(component) {
        const self = this;
        const approveButton = component.querySelector('.js-age-gate-approve');

        checkPermission();

        approveButton.addEventListener('click', approve);

        function approve() {
            Cookies.set('ciwc-age-gate', 'verified', { expires: 7 });

            hideAgeGate();
        }

        function checkPermission() {
            const permission = Cookies.get('ciwc-age-gate');

            if (permission === 'verified') {
                hideAgeGate();
            } else {
                showAgeGate();
            }
        }

        function hideAgeGate() {
            component.classList.remove('is-active');

            self.Main.unlockScroll();
            // self.lenis.start();
        }

        function showAgeGate() {
            component.classList.add('is-active');

            self.Main.lockScroll();
            // self.lenis.stop();
        }
    }
}

export default AgeGate;
